module.exports = __webpack_public_path__ + "img/stats-bar-dark-01.6d73d5f5.jpg";